import Swal from "sweetalert2";
import axios from "axios";

const initialState = {
  isEnabled: true,
  isReady: false,
  isExpired: false,
  isVerified: false,
  isLoaded: false,
  code: null,
  imageSrc: null,
  isBypassed: false,
};

export const qr = { ...initialState };

export function useQR() {
  const qrKey = process.env.VUE_APP_QR_KEY;
  let qrInterval = "";

  const resetQr = () => Object.assign(qr, initialState);
  const onQrLoad = () => (qr.isLoaded = true);

  const bypassQr = () => {
    clearInterval(qrInterval);
    acceptQr(true);
  };

  const acceptQr = (isBypassed) => {
    Swal.fire({
      title: "QR Verified",
      icon: "success",
    }).then(() => {
      qr.isVerified = true;
      qr.isBypassed = isBypassed;
    });
  };

  const generateQr = async () => {
    resetQr();

    await axios
      .get(`${process.env.VUE_APP_QR_URL}/generate/${qrKey}`, {
        headers: {
          accept: "application/json",
        },
      })
      .then((res) => {
        const response = res.data;
        qr.code = response.result.qr_code;
        qr.isReady = true;
        qr.imageSrc = response.result.qr_image;
      });

    checkStatus();
  };

  const checkStatus = async () => {
    qrInterval = setInterval(() => {
      if (qr.isVerified) return;
      axios
        .get(`${process.env.VUE_APP_QR_URL}/check/${qrKey}`, {
          headers: {
            accept: "application/json",
          },
          params: { qr_code: qr.code },
        })
        .then((res) => {
          const response = res.data;
          if (response.result.status === 1) {
            clearInterval(qrInterval);
            acceptQr(false);
          }
        })
        .catch(() => {
          qr.isExpired = true;
          clearInterval(qrInterval);
        });
    }, 3000);

    return new Promise((resolve) => {
      resolve(qrInterval);
    });
  };

  return {
    checkStatus,
    generateQr,
    onQrLoad,
    bypassQr,
  };
}
